export const getModelImageId = (
  modelImages: ModelImage[] | undefined,
  appearanceId: string,
  viewId: string
) => {
  return modelImages?.find((model) => {
    return (
      !!model.active &&
      model.viewId === viewId &&
      model.appearanceIds.some((aid) => aid === appearanceId)
    );
  })?.modelId;
};

export const getModelImagesForAppearanceAndView = (
  modelImages: ModelImage[] | undefined,
  appearanceId: string,
  viewId: string
) => {
  if (!modelImages) return [];
  return modelImages.filter((modelImage) => {
    return (
      modelImage.active &&
      modelImage.appearanceIds.includes(appearanceId) &&
      modelImage.viewId === viewId
    );
  });
};
